import {inject, Injectable, Injector} from '@angular/core';
import {each, find, get} from "lodash-es";
import {
  EventNotifier,
  getWmProjectProperties,
  isDefined,
  Viewport,
  registerFnByExpr
} from '@wm/core';
import { ProjectService, StudioService, UserService} from "@wms/services";
import { BaseVariableService } from "@wms/variables";
import { I18nService } from "@wms/services";

const enum PROJECT_TYPE {
  APPLICATION = 'APPLICATION',
  PREFAB = 'PREFAB',
  TEMPLATE_BUNDLE = 'TEMPLATEBUNDLE'
}

const noop = (...args: any[]) => {};

// Wraps httpService to behave as angular 1.x $http service.
// const getHttpDependency = function() {
//   const httpService = this.httpService;
//   const fn = function (key, options?) {
//     const args = Array.from(arguments).slice(1);
//     return Promise.resolve(httpService[key].apply(httpService, args));
//   };
//   const $http = function () {
//     return fn.apply(undefined, ['send', ...Array.from(arguments)]);
//   };
//   ['get', 'post', 'head', 'put', 'delete', 'jsonp', 'patch'].forEach(key => $http[key] = fn.bind(undefined, key));
//   return $http;
// };

@Injectable()
export class AppRef {
  // Variables: any = {};
  Actions: any = {};
  onAppVariablesReady = noop;
  onSessionTimeout = noop;
  onPageReady = noop;
  onBeforePageLeave = noop;
  onBeforeServiceCall =  noop;
  onServiceSuccess =  noop;
  onServiceError =  noop;
  dynamicComponentContainerRef: any = {};

  projectName: string;
  platformType: string;
  isPrefabType: boolean;
  isApplicationType: boolean;
  isTabletApplicationType: boolean;
  isTemplateBundleType: boolean;

  appLocale: any;
  selectedOrganization: any;
  apiDocsURL: any;

  // TODO: implement this
  activePageName: string;

  private _eventNotifier = new EventNotifier();
  private baseVariableService: BaseVariableService;
  landingPageName = getWmProjectProperties().homePage;

  reload() {
    window.location.reload();
  }

  constructor(
    private inj: Injector,
    private userService: UserService,
    private studioService: StudioService,
    private i18nService: I18nService
    // private statePersistence: StatePersistence,
    // private httpService: AbstractHttpService,
    // private securityService: SecurityService,
    // private routeReuseStrategy: RouteReuseStrategy
  ) {
    // const projectDetails = inject(ProjectService);
    // console.log(projectDetails);

    const wmProjectProperties = inject(ProjectService).getDetails();

    this.projectName = wmProjectProperties.name;
    this.platformType = wmProjectProperties.platformType;
    this.isPrefabType = wmProjectProperties.type === PROJECT_TYPE.PREFAB;
    this.isApplicationType = wmProjectProperties.type === PROJECT_TYPE.APPLICATION;
    this.isTemplateBundleType = wmProjectProperties.type === PROJECT_TYPE.TEMPLATE_BUNDLE;

    // this.httpService.registerOnSessionTimeout(this.on401.bind(this));

    this.appLocale = this.i18nService.appLocale || this.i18nService.getAppLocale();
    // this.httpService.setLocale(this.appLocale);
    this.baseVariableService = inject(BaseVariableService);
  }



  getStudioInfo() {
    this.studioService.getStudioInfo().then(info => {
      this.apiDocsURL = '/app-runtime/'+ get(info, 'product.serviceVersions')[get(info, 'product.latestReleaseVersion')]['wavemaker.app.runtime.ui.version'] + '/docs';
    })
  }
  // public clearPageCache(pageName?: string) {
  //   if(this.routeReuseStrategy instanceof WmDefaultRouteReuseStrategy) {
  //     (this.routeReuseStrategy as WmDefaultRouteReuseStrategy).reset(pageName);
  //   }
  // }

  public notify(eventName: string, ...data: Array<any>) {
    // @ts-ignore
    this._eventNotifier.notify.apply(this._eventNotifier, arguments);
  }

  public getDependency(injToken: any) {
    return {};
  }

  /**
   * triggers the onSessionTimeout callback in app.js
   */
  // on401() {
  //   const userInfo = get(this.securityService.get(), 'userInfo');
  //   // if a previous user exists, a session time out triggered
  //   if (!isEmpty(userInfo)) {
  //     this.onSessionTimeout();
  //   }
  // }

  public subscribe(eventName: string, callback: (data: any) => void): () => void {
    return this._eventNotifier.subscribe(eventName, callback);
  }

  public notifyApp(template: string, type: string, title: any) {
    const notificationAction = get(this, 'Actions.appNotification');
    const EXCLUDE_NOTIFICATION_MESSAGES = ['PROCESS_REJECTED_IN_QUEUE'];
    const skipDefaultNotification = EXCLUDE_NOTIFICATION_MESSAGES.indexOf(template) !== -1;
    if (notificationAction) {
      // do not notify the error to the app, just throw it in console
      if (skipDefaultNotification) {
        console.warn('App Error', template);
        return;
      }
      type = type || 'success';
      template = notificationAction.getMessage() || template;
      notificationAction.invoke({
        message: template,
        title: isDefined(title) ? title : type.toUpperCase(),
        class: type,
        // If the type is error do not close the toastr
        duration: type.toUpperCase() === 'ERROR' ? 0 : undefined
      });
    } else {
      console.warn('The default Action "appNotification" doesn\'t exist in the app. App notified following error:\n', template);
    }
  }

  /**
   * function to register bind expressions from app variables
   * it will be called from app.js in generated angular app
   * @param expressions, map of bind expression vs generated function
   */
  public registerExpressions(expressions: any) {
    each(expressions, (fn, expr)=>{
      registerFnByExpr(expr, fn[0], fn[1]);
    });
  }

  get Variables() {
    return this.baseVariableService.variableCollection.App;
  }

}
